var _style, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEyeSolid(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Lager_1",
    focusable: "false",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 576 512",
    style: {
      enableBackground: "new 0 0 576 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#3A404E;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M572.5,241.4C518.3,135.6,410.9,64,288,64S57.7,135.6,3.5,241.4c-4.6,9.2-4.6,20,0,29.2 C57.7,376.4,165.1,448,288,448s230.3-71.6,284.5-177.4C577.2,261.4,577.2,250.6,572.5,241.4z M288,400c-79.5,0-144-64.5-144-144 s64.5-144,144-144s144,64.5,144,144c0,79.5-64.4,144-143.9,144C288.1,400,288,400,288,400z M288,160c-8.6,0.1-17.1,1.4-25.3,3.8 c15.7,21.3,11.1,51.2-10.2,66.9c-16.9,12.4-39.9,12.4-56.7,0c-13.9,51.1,16.3,103.7,67.3,117.5c51.1,13.9,103.7-16.3,117.5-67.3 c13.9-51.1-16.3-103.7-67.3-117.5C305.1,161.1,296.5,160,288,160z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeSolid);
export default __webpack_public_path__ + "static/media/eye-solid.b14a355ce16d3881427b8e4df6b04e1a.svg";
export { ForwardRef as ReactComponent };